import { Button, Modal } from 'antd'
import TermContent from 'web/TermContent/TermContent'
import { VISITED } from 'configs/constant'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const ModalPolicy = () => {
  const [openModalPolicy, setOpenModalPolicy] = useState<boolean>(false)
  const { t } = useTranslation()

  useEffect(() => {
    const isApprove = localStorage.getItem(VISITED)
    if (!isApprove) {
      setOpenModalPolicy(true)
    }
  }, [])

  return (
    <Modal
      closeIcon={null}
      width={'70vw'}
      className='modal-policy modal-common'
      title={t('term')}
      centered
      footer={
        <Button className="button-accept" type='primary' onClick={() => {
          setOpenModalPolicy(false)
          localStorage.setItem(VISITED, 'true')
        }}
        style={{ background: '#1677FF' }}
        >
          {t('button.accept')}
        </Button>
      }
      open={openModalPolicy}
    >
      <TermContent />
    </Modal>
  )
}

export default ModalPolicy